
import React from 'react';
import Parser from 'html-styled-react-parser';
import styled from 'styled-components';

const HTMLParser = ({html,type}) => {
    const filter = html !== undefined && html !== null ? html.replace(/(style=")(.*)(\")|&nbsp;/g,' ').replace(/&amp;/g,'&').split(' , ') : '';
    const filterHTML = html !== undefined && html !== null ? html.replace(/<\/?p[^>]*>|<\/?img[^>]*>|<\/?span[^>]*>|(style=")(.*)(\")|&nbsp;/g,"").split(' , '): '';
    
    const StoryReplacement = {
        IMG: Image,
        P:StoryDescription,
        SPAN:StoryDescription,
        H3:Heading,
        STRONG:Bold,
        BR:Spacer,
        UL:List,
        LI:Item,
      }

      const CardReplacement = {
        P:Description,
        SPAN:Description,
        H3:()=><span></span>,
        STRONG:()=><span></span>,
        BR:Spacer,
        IMG:()=><span></span>,
        UL: ()=><span></span>,
        OL: ()=><span></span>,
        LI: ()=><span></span>
      }

      const MilestoneReplacement = {
        P:MilestoneDescription,
        SPAN:MilestoneDescription,
        H3:MilestoneHeading,
        STRONG:KeyPoint,
        // BR:Break,
        IMG:Donor
      }

      const replace = type === 'card' ? CardReplacement : type === 'story' ? StoryReplacement : type === 'milestone' ? MilestoneReplacement : StoryReplacement;
    
  return (
    <Parser html={type === 'card' ? filterHTML[0] : filter[0]} replacements={replace}/>
  )
}

export default HTMLParser;




const Description = styled.p`
    height:100% ;
    color:red;
    font-family:'Poppins';
    font-weight:400;
    font-size:0.9rem;
    line-height:20px;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`


let Heading = styled.div`
    font-size:1.2rem;
    font-family:'Poppins';
    font-weight:400;
    color:#4472C4;
`

let Head = styled.span`
    color:#A5A3C2;
    font-family:'Poppins';
    font-weight:400;
    font-size:12px;
`


let StoryDescription = styled.p`
  font-family:'Poppins';
  font-weight:400;
  font-size:0.9rem;
  color:#232323;
  margin-block:10px;
  text-align:justify;
  padding-right: 10px;
  @media (max-width:768px){
  padding-right: 0px;

  }
`

let MilestoneHeading = styled.p`
    font-size:2.5rem;
    font-family:'Poppins';
    font-weight:700;
    color:#4472C4;
    text-transform:uppercase ;
    @media (max-width:900px){
      font-size:2rem;
    }
`

let MilestoneDescription = styled.p`
    font-family:'Poppins';
    font-weight:400;
    font-size:1rem;
    color:#000;
    width:100%;
    text-align:left;
    line-height:30px;
    @media (max-width:900px){
    font-size:0.9rem;
    width:100%;
    overflow:hidden;
    word-break:break-all;
    }
`
let Donor = styled.img`
    width:30px;
    margin-right:3px ;
`


let KeyPoint = styled.span`
    font-family:'Poppins';
    font-weight:700;
    font-size:1rem;
    color:#000;
    margin-top:5px;
    @media (max-width:900px){
    font-size:0.9rem;
    }
`

let Bold = styled.strong`
  font-family:'Poppins';
  font-weight:700;
  font-size:1.1rem;
`

let List = styled.ul`
    margin-top:15px ;
    `

let Item = styled.li`
font-size: 0.9rem;
    margin-top:10px ;
    margin-left: -15px;
    ::marker{
        color:#C6C661;
    }

`

const Image = styled.img`
    width:99% ;
    height:100%;
    background-size: contain ;
    background-repeat: repeat-x;
    background-position: 50% auto;
    border-radius:13px ;
    @media (max-width: 768px) {
    width:100% ;
    height:100%;
    }
`

let Spacer = styled.span`
  ::after{
    content:' '
  }
`